<template>
  <ion-menu side="start" content-id="content">
    <ion-header>
      <ion-toolbar>
        <ion-title>Menu</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item
          v-if="userIsAdmin || userIsRunner || userIsVendor"
          @click="navigate('Web: Order Dashboard')"
          button="true"
          data-cy="menu-item-order-dashboard"
        >
          <ion-icon name="home" slot="start"></ion-icon>
          <ion-label>Order Dashboard</ion-label>
        </ion-item>
        <ion-item
          v-if="userIsAdmin"
          @click="navigate('Web: Location List')"
          button="true"
          data-cy="menu-item-location-list"
        >
          <ion-icon name="navigate" slot="start"></ion-icon>
          <ion-label>Locations</ion-label>
        </ion-item>
        <ion-item
          v-if="userIsAdmin || userIsVendor"
          @click="navigate('Web: Reports')"
          button="true"
          data-cy="menu-item-reports"
        >
          <ion-icon name="stats" slot="start"></ion-icon>
          <ion-label>Reports</ion-label>
        </ion-item>
        <ion-item
          v-if="userIsAdmin"
          @click="navigate('Web: User List')"
          button="true"
          data-cy="menu-item-user-list"
        >
          <ion-icon name="people" slot="start"></ion-icon>
          <ion-label>Users</ion-label>
        </ion-item>
        <ion-item
          v-if="userIsAdmin || userIsRunner || userIsVendor"
          @click="navigate('Account Settings')"
          button="true"
          data-cy="menu-item-account-settings"
        >
          <ion-icon name="person" slot="start"></ion-icon>
          <ion-label>Account Settings</ion-label>
        </ion-item>
        <ion-item
          @click="navigate('Support and Contact')"
          button="true"
          data-cy="menu-item-support-and-contact"
        >
          <ion-icon name="help-buoy" slot="start"></ion-icon>
          <ion-label>Support and Contact</ion-label>
        </ion-item>
        <ion-item v-if="hasLabMenu" @click="navigate('Lab')" button="true">
          <ion-icon name="planet" slot="start"></ion-icon>
          <ion-label>Lab</ion-label>
        </ion-item>
        <ion-item
          @click="handleSignOut()"
          button="true"
          data-cy="menu-item-sign-out"
        >
          <ion-icon name="log-out" slot="start"></ion-icon>
          <ion-label>Sign Out</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
        <div class="ion-text-center" v-super-long-press="showLabMenu">
          Stay Seated
        </div>
      </ion-toolbar>
    </ion-footer>
  </ion-menu>
</template>

<script>
import { mapGetters } from "vuex";
import SideMenuBase from "@/components/Shared/SideMenuBase";

export default {
  extends: SideMenuBase,
  computed: {
    ...mapGetters("auth", ["userIsAdmin", "userIsVendor", "userIsRunner"])
  }
};
</script>
